import { apiFetch } from './supabaseClient';
import {
  NFC_READER_ERRORS,
  NfcReaderError,
  validateSunNfcUri,
} from './nfcReader';

const SUBMIT_TIMEOUT_MS = 15000;

function randomUuid() {
  const cryptoObject = globalThis.crypto;
  if (typeof cryptoObject?.randomUUID === 'function') {
    return cryptoObject.randomUUID();
  }
  if (typeof cryptoObject?.getRandomValues === 'function') {
    const bytes = new Uint8Array(16);
    cryptoObject.getRandomValues(bytes);
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = Array.from(bytes, (value) => value.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
  }
  throw new Error('Secure random generator unavailable');
}

export function createNfcIdempotencyKey() {
  return randomUuid();
}

export async function submitNfcAttendance(sunUrl) {
  const { sunUrl: verifiedShape } = validateSunNfcUri(sunUrl);

  const controller = typeof AbortController === 'undefined'
    ? null
    : new AbortController();
  const timeoutId = setTimeout(() => controller?.abort(), SUBMIT_TIMEOUT_MS);
  try {
    return await apiFetch('/api/attendance/nfc', {
      method: 'POST',
      body: JSON.stringify({ sun_url: verifiedShape }),
      ...(controller ? { signal: controller.signal } : {}),
    });
  } catch (error) {
    if (error?.name === 'AbortError') {
      throw new NfcReaderError(
        NFC_READER_ERRORS.SUBMIT_TIMEOUT,
        'L’invio della presenza ha superato il tempo massimo.',
        error,
      );
    }
    throw error;
  } finally {
    clearTimeout(timeoutId);
  }
}